export default "__VITE_ASSET__BosdsHzI__"